<template>
  <footer class="app-footer" role="contentinfo">
  <div>
    <div class="fbf-logo">
      <div class="fbf-logo-wrapper">
        <a href="https://www.fagbokforlaget.no/" target="_blank"></a>
      </div>
    </div>

    <div class="fbf-social-media">
      <div class="fbf-social-media-wrapper">
        <a class="social-1" href="https://www.facebook.com/Fagbokforlaget" target="_blank"></a>
      </div>

      <div class="fbf-social-media-wrapper">
        <a class="social-2" href="https://twitter.com/Fagbokforlaget" target="_blank"></a>
      </div>

      <div class="fbf-social-media-wrapper">
        <a class="social-3" href="https://www.linkedin.com/company/fagbokforlaget-v&b-as" target="_blank"></a>
      </div>
      <div class="fbf-social-media-wrapper">
        <a class="social-4" href="https://issuu.com/fagbokforlaget" target="_blank"></a>
      </div>
    </div>
    <div class="fbf-icon-container">
        <div class="icon-wrapper">
          <a href="/personvern"><span class="privacy-icon"></span><span class="privacy-link">Personvern</span></a>
        </div>
        <div class="icon-wrapper">
          <a href="https://www.fagbokforlaget.no/kontakt" target="_blank"><span class="contact-icon"></span><span class="contact-link">Kontakt oss</span></a>
        </div>
    </div>
  </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
